import { UserGroupIcon } from "@heroicons/react/solid";
import React, { useState } from "react";
import {
  countGSM7bitEx,
  detectTextEncoding,
  GSM_7BIT_EX,
  multiSMSTypeLength,
  smsTypeLength,
} from "../../utils/Helpers";
import HowToUse from "./HowToUse";
import MessageAnalyzer from "./MessageAnalyzer";

interface SMSCostComponentProps {}

const SMSCostComponent: React.FC<SMSCostComponentProps> = () => {
  const sms_price = 0.062;
  const [smsCharacters, setSMSCharacters] = useState<string[]>([]);
  const [smsCharacterLength, setSMSCharacterLength] = useState<number>(0);
  const [smsMessages, setSMSMessages] = useState<number>(0);
  const [totalCost, setTotalCost] = useState<number>(0);
  const [targetAudience, setTargetAudience] = useState<any>(undefined);

  const smsTextHandler = (text: string) => {
    setSMSCharacters([...text]);
    const encoding = detectTextEncoding(text);
    let smsCharacterLength = text.length;

    if (encoding === GSM_7BIT_EX) {
      smsCharacterLength += countGSM7bitEx(text);
    }

    let perMessage = smsTypeLength[encoding];

    if (smsCharacterLength > perMessage) {
      perMessage = multiSMSTypeLength[encoding];
    }

    const smsMessages = Math.ceil((smsCharacterLength + 7) / perMessage);
    const totalCost =
      targetAudience > 0
        ? sms_price * targetAudience * smsMessages
        : sms_price * smsMessages;
    setSMSCharacterLength(smsCharacterLength);
    setSMSMessages(smsMessages);
    setTotalCost(totalCost);
  };

  const calculateCost = (input: string) => {
    setTargetAudience(input);
    const targetAudience = Number(input);
    if (smsMessages > 0 && targetAudience > 0) {
      const smsCost = sms_price * smsMessages;
      setTotalCost(smsCost * targetAudience);
    } else {
      setTotalCost(sms_price * smsMessages);
    }
  };

  return (
    <React.Fragment>
      <div className="grid grid-flow-row grid-cols-3 gap-4">
        <div className="col-span-full sm:col-span-2 shadow border rounded-md p-4">
          <textarea
            id="sms-text"
            name="sms-text"
            rows={9}
            className="focus:outline-none mt-1 block w-full text-md sm:text-lg resize-none 
                        font-medium text-gray-800"
            placeholder="Type your text message here"
            onChange={(e) => smsTextHandler(e.target.value)}
          />
          <div className="block">
            <span className="bg-pink-600 inline-block mr-2 mt-2 rounded px-1.5 py-0.5 text-white text-sm">
              Characters: {smsCharacterLength}
            </span>
            <span className="bg-pink-600 inline-block mr-2 mt-2 rounded px-1.5 py-0.5 text-white text-sm">
              Messages: {smsMessages}
            </span>

            {smsMessages > 1 && (
              <span className="bg-yellow-200 inline-block rounded px-1.5 py-0.5 mt-2 sm:mt-0 text-gray text-sm">
                Caution! This text will be sent as {smsMessages} messages.
              </span>
            )}
          </div>
        </div>
        <div className="col-span-full sm:col-span-1 shadow border rounded-md p-6 px-10 w-full">
          <h2 className="text-base mb-7 sm:mb-0 font-bold tracking-wide uppercase text-center">
            Estimated Cost
          </h2>
          <div className="flex flex-col justify-center h-full">
            <h1 className="text-base mb-7 sm:mb-0 font-extrabold tracking-wide uppercase text-center text-4xl">
              RM {totalCost > 999 ? totalCost.toFixed(2) : totalCost.toFixed(3)}
            </h1>
            {/* <div className='mt-1 flex rounded shadow'>
                            <div
                                className='has-tooltip inline-flex items-center px-3 rounded-l-md border 
                            border-r-0 border-gray-300 bg-gray-50 text-gray-500'
                            >
                                <span className='tooltip rounded shadow-lg p-1 bg-gray-100 text-gray-500 -mt-14 -ml-9 capitalize'>
                                    Target Audience
                                </span>
                                <UserGroupIcon className='h-5 w-5' aria-hidden='true' />
                            </div>
                            <input
                                type='number'
                                placeholder='Target Audience'
                                aria-describedby='basic-addon2'
                                value={targetAudience}
                                className='border focus:outline-none focus:ring-1 focus:ring-pink-500 
                                focus:ring-opacity-50 px-4 block w-full border-gray-300 rounded-r-md h-10'
                                onChange={(event) => calculateCost(event.target.value)}
                            />
                        </div> */}
          </div>
        </div>
      </div>
      <div className="pt-8">
        <MessageAnalyzer smsCharacters={smsCharacters} />
      </div>
      <div className="pt-8">
        <HowToUse />
      </div>
    </React.Fragment>
  );
};

export default SMSCostComponent;
